// extracted by mini-css-extract-plugin
module.exports = {"bookmarkWrapper":"Bookmark_bookmarkWrapper___VcGA","bookmarkBg":"Bookmark_bookmarkBg__1HIT5"};